exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promo-text[data-v-e4bdceec]{padding-bottom:15px;border-bottom:1px solid #D1D1D1}\n", ""]);

// exports
